/**
 * Global History is execution-based.
 * historyId identifies one execution; requestId only references the current Request.
 */

export function historyDetailQueryKey(historyId: number): readonly ['history-detail', number] {
  return ['history-detail', historyId] as const;
}

/** Rapid-click guard: only apply a detail response for the still-selected historyId. */
export function isLatestHistorySelection(
  selectedHistoryId: number | null | undefined,
  responseHistoryId: number
): boolean {
  return selectedHistoryId != null && selectedHistoryId === responseHistoryId;
}

/**
 * Append page rows by historyId only — never collapse repeated executions of the same requestId.
 */
export function mergeHistorySummariesByHistoryId<T extends { id: number }>(
  existing: T[],
  incoming: T[]
): T[] {
  const existingIds = new Set(existing.map((item) => item.id));
  const nextItems = incoming.filter((item) => !existingIds.has(item.id));
  return [...existing, ...nextItems];
}

/** True when two history rows are distinct executions even if they share requestId. */
export function areDistinctExecutions(
  a: { id: number; requestId?: number | null },
  b: { id: number; requestId?: number | null }
): boolean {
  return a.id !== b.id;
}
